module.exports = __webpack_public_path__ + "img/gift4.98c60b0c.png";